import { defineMessages } from "react-intl";

const messages = defineMessages({
  applyTemplate: {
    id: "email.creation.templateButton.applyTemplate",
    defaultMessage: "Apply Template",
    description: "Manage email templates modal - Apply Template",
  },
  cancel: {
    id: "email.creation.templateButton.cancel",
    defaultMessage: "Cancel",
    description: "Cancel",
  },
  clear: {
    id: "email.creation.templateButton.clear",
    defaultMessage: "Clear",
    description: "Clear action",
  },
  clearConfirmationText: {
    id: "email.creation.templateButton.clearConfirmation.text",
    defaultMessage: "All changes to template will be lost. Continue?",
    description: "Clear confirmation text",
  },
  deleteConfirmationCancel: {
    id: "email.creation.templateButton.deleteConfirmation.cancel",
    defaultMessage: "Cancel",
    description: "Manage email templates modal - Cancel",
  },
  deleteConfirmationOk: {
    id: "email.creation.templateButton.deleteConfirmation.ok",
    defaultMessage: "Delete",
    description: "Manage email templates modal - Delete",
  },
  mostRecent: {
    id: "email.creation.templateButton.mostRecent",
    defaultMessage: "Most Recent",
    description: "Manage email templates modal - Most Recent",
  },
  save: {
    id: "email.creation.templateButton.save",
    defaultMessage: "Save",
    description: "Save",
  },
  saveNew: {
    id: "email.creation.templateButton.saveNew",
    defaultMessage: "Save New",
    description: "Manage email templates modal - Save New",
  },
  saveNewDisabled: {
    id: "email.creation.templateButton.saveNewDisabled",
    defaultMessage: "Fill out both subject and body to save new template",
    description: "Manage email templates modal - save new disabled",
  },
  saveNewDisabledReply: {
    id: "email.creation.templateButton.saveNewDisabledReply",
    defaultMessage: "Fill out body to save new template",
    description: "Manage email templates modal - save new disabled for reply",
  },
  saveNewSharedDescription: {
    id: "email.creation.templateButton.saveNewSharedDescription",
    defaultMessage: "This template was shared with you. You can only save a new version.",
    description: "Manage email templates modal - save new shared description",
  },
  saveNewTemplate: {
    id: "email.creation.templateButton.saveNewTemplate",
    defaultMessage: "Save New Template",
    description: "Manage email templates modal - Save New",
  },
  seeMore: {
    id: "email.creation.templateButton.moreTemplates",
    defaultMessage: "More Templates",
    description: "Manage email templates modal - See More",
  },
  selectTemplate: {
    id: "email.creation.templateButton.selectTemplate",
    defaultMessage: "Select Template",
    description: "Manage email templates modal - Select Template",
  },
  templateName: {
    id: "email.creation.templateButton.templateName",
    defaultMessage: "Template Name",
    description: "Template Name",
  },
  update: {
    id: "email.creation.templateButton.update",
    defaultMessage: "Update",
    description: "Update",
  },
  updateConfirmationCancel: {
    id: "email.creation.templateButton.updateConfirmation.cancel",
    defaultMessage: "No",
    description: "Manage email templates modal - Cancel",
  },
  updateConfirmationOk: {
    id: "email.creation.templateButton.updateConfirmation.ok",
    defaultMessage: "Yes",
    description: "Manage email templates modal - Update",
  },
  updateConfirmationText: {
    id: "email.creation.templateButton.updateConfirmation.text",
    defaultMessage: "This template will be overridden by the current email. Continue?",
    description: "Manage email templates modal - Are you sure you want to update this template?",
  },
  updateDescription: {
    id: "email.creation.templateButton.updateDescription",
    defaultMessage: "Save changes to template",
    description: "Update Description",
  },
  updateSharedConfirmationText: {
    id: "email.creation.templateButton.updateSharedConfirmationText.text",
    defaultMessage:
      "This template will be overridden by the current email. These changes will apply to all users this template is shared with. Continue?",
    description:
      "Manage email templates modal - Are you sure you want to update this shared template?",
  },
});

export default messages;
